import * as React from 'react';

import styled from 'styled-components';

interface AnalyticsContainerProps {
  className?: string;
  children?: React.ReactNode;
}

export const AnalyticsContainer: React.FC<AnalyticsContainerProps> = (
  props
) => {
  return (
    <section className={props.className}>
      <div className="content">{props.children}</div>
    </section>
  );
};

export default styled(AnalyticsContainer)`
  padding: 32px 24px 80px;
  max-width: 1440px;
  margin: 0 auto;
  min-height: 100vh;

  @media ${({ theme }) => theme.device.tablet} {
    padding-block: 48px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(24, minmax(0, 1fr));

    .content {
      grid-column: span 24;
    }
  }

  @media ${({ theme }) => theme.device.laptopS} {
    .content {
      grid-column: 4 / 22;
    }
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding-block: 80px;
  }

  @media ${({ theme }) => theme.device.desktopL} {
    padding-block: 130px;
  }
`;
